import axios from 'axios'

if(process.env.NODE_ENV === 'production') {
  // npm run build
    axios.defaults.baseURL = 'https://api.wormhole.biz'  
} else {
    axios.defaults.baseURL = 'http://oversea-tob-website-api.local'
}

// 请求前拦截
axios.interceptors.request.use(config => {
    return config
})

// 响应拦截
axios.interceptors.response.use(
    response => {
        return response
    },
    error => {
        return Promise.reject(error)
    }
)

export default function request({
    url,
    method = 'get',
    params = {},
    data = {},
}) {
    return axios({
        url,
        method,
        params,
        data,
    })    
}